import { connect } from 'react-redux';
import LatestDNSRecordsExploreRecipe from './components/LatestDNSRecordsExploreRecipe';
import {
  saveMergeAPIExploreRecipeLatestDNSRecords,
  loadMergeAPIExploreRecipeLatestDNSRecords,
  deleteMergeAPIExploreRecipeLatestDNSRecords,
  updateMergeAPIExploreRecipeLatestDNSRecords,
  changeScopeMergeAPIExploreRecipeLatestDNSRecords,
  resetRecipeStatus,
  clearExploreDetails,
  loadUtilsParseIOC,
  resetUtilsParseIOCStatus,
  cloneRecipe,
} from '../../redux/actions/ioc';
import { loadUser, loadMySubscriptionPlan } from '../../redux/actions/user';

const mapStateToProps = (state) => ({
  recipeStatusLatestDNSRecords: state.ioc.recipeStatusLatestDNSRecords,
  exploreRecipeLatestDNSRecords: state.ioc.exploreRecipeLatestDNSRecords,
  exploreRecipe: state.ioc.exploreRecipe,
  parsedIOCStatus: state.ioc.parsedIOCStatus,
  parsedIOC: state.ioc.parsedIOC,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  loadUser,
  resetRecipeStatus,
  saveMergeAPIExploreRecipeLatestDNSRecords,
  loadMergeAPIExploreRecipeLatestDNSRecords,
  updateMergeAPIExploreRecipeLatestDNSRecords,
  deleteMergeAPIExploreRecipeLatestDNSRecords,
  changeScopeMergeAPIExploreRecipeLatestDNSRecords,
  clearExploreDetails,
  loadUtilsParseIOC,
  resetUtilsParseIOCStatus,
  cloneRecipe,
  loadMySubscriptionPlan,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LatestDNSRecordsExploreRecipe);
